<template>
  <div class="coursequestionbank">
    <div class="header">
      <el-form style="width: 100%">
        <el-form-item>
          <el-col>
            <el-button size="small" type="primary" @click="$router.push('/Education/questionentry')">添加试题</el-button>
            <el-button size="small" type="primary" @click="importdialog=true">试题导入</el-button>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-col style="width: 50px;">{{ $t('Education.languages45') }}：</el-col>
          <el-col :span="3">
            <el-select 
            v-model="param.courseId" 
            filterable 
            clearable 
            :placeholder="$t('Education.languages18')" 
            :filter-method="filterCourse">
              <el-option
                  v-for="item in CoureRestaurants"
                  :key="item.courseId"
                  :label="item.courseName"
                  :value="item.courseId">
              </el-option>
            </el-select>
          </el-col>
          <el-col style="width: 50px;margin-left: 20px">章节：</el-col>
          <el-col :span="3">
            <el-select 
            v-model="param.chapterId" 
            filterable clearable
            :disabled="chapterstatue"
            placeholder="请先选择课程"
            :filter-method="filterchapter"
            >
            <el-option
                v-for="item in chapterlistData"
                :key="item.chapterId"
                :label="item.chapterName"
                :value="item.chapterId">
            </el-option>
          </el-select>
          </el-col>
          <el-col style="width: 50px;margin-left: 20px">题型：</el-col>
          <el-col :span="3">
            <el-select v-model="param.questionType" clearable :placeholder="$t('Education.languages18')">
            <el-option
                v-for="item in topicTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          </el-col>
          <el-col :span="4" style="margin-left: 20px">
            <el-input v-model="param.searchValue" placeholder="请输入题目名/录入人"></el-input>
          </el-col>
          <el-col :span="5" style="margin-left: 20px">
            <el-button type="primary" @click="list(0)">{{ $t('Education.languages01') }}</el-button>
            <el-button type="primary" @click="Clickreset">重置</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <div class="content">
      <el-table
          v-loading="exammanageload"
          :data="exammanageData"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%;text-align: center">
        <el-table-column prop="courseName" label="课程"></el-table-column>
        <el-table-column prop="chapterName" label="章节"></el-table-column>
        <el-table-column prop="questionTitle" label="题目"></el-table-column>
        <el-table-column prop="type" label="题型"></el-table-column>
        <el-table-column prop="createBy" label="录入人"></el-table-column>
        <el-table-column prop="createTime" label="录入时间"></el-table-column>
        <el-table-column :label="$t('Education.languages42')" >
          <template v-slot="scope">
            <el-popconfirm
              @confirm="ClickDelete(scope.row)"
              title="是否确定删除？"
            >
              <span class="operateitem" slot="reference">{{ $t('Education.languages07')}}</span>
            </el-popconfirm>
            <span class="operateitem" @click="$router.push({path:'/Education/questionentry',query:{questionId:scope.row.questionId},replace: true})">{{ $t('Education.languages08') }}</span>
            <span class="operateitem" @click="ClickDetail(scope.row.questionId)">{{ $t('Education.languages09') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page.sync="param.pageNum"
        :page-size="param.pageSize"
        layout="total, prev, pager, next"
        :total="param.Total">
      </el-pagination>
    </div>

<!--  详情弹窗  -->
    <el-drawer
        :size="500"
        :visible.sync="topicdetail">
      <questiondetail :questionId="questionId" @questiondetail="topicdetail=false"></questiondetail>
    </el-drawer>

    <!-- 导入弹窗 -->
    <el-dialog
      title="批量导入"
      :visible.sync="importdialog"
      >
      <div style="text-align: center;">
        <el-upload
          class="upload-demo"
          v-loading="Loading"
          ref="upload"
          :auto-upload="false"
          :action="actionUrl"
          :headers="{'Authorization':AuthorizationToken}"
          accept="xlsx,xls"
          :before-upload="beforeupload"
          :on-success="handsuccess"
          :file-list="fileList"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"><em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx,xls文件，且不超过10MB<span style="color: #409EFF;cursor: pointer;" @click="Clickdownload">试卷模板下载</span></div>
        </el-upload>


        <div style="margin: 20px 0;">
            <el-button type="primary" @click="submitUpload">确认</el-button>
            <el-button @click="importdialog=false">取消</el-button>
          </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import questiondetail from './component/questiondetail.vue';
export default ({
  name:'coursequestionbank',
  data(){
    return{
      AuthorizationToken:sessionStorage.getItem('Authorization'),
      fileList:[],
      actionUrl:process.env.VUE_APP_URL+'edu/question/import',
      importdialog:false,
      questionId:'',
      exammanageload:true,
      topicdetail:false,
      CourseName:'',
      chapterlistData:[],
      CoureRestaurants:[],
      Loading:false,
      topicTypeList:[{value:1,label: '单选题'},{value:2,label: '多选题'},{value:4,label: '问答题'}],
      exammanageData:[],
      examListID:[],
      chapterstatue:true,
      param:{
        courseId:'',
        chapterId:'',//章节id
        questionType:'',//题目类型
        pageNum:1,
        pageSize:10,
        searchValue:'',
        Total:0
      },
      CoureseParam:{
        courseName:'',
        pageNum:1,
        pageSize:20
      },
      chapterparam:{
        courseId:'',
        chapterName:'',
        pageNum:1,
        pageSize:20
      },

    }
  },
  watch:{
    'param.courseId'(newval,oldval){
      if(newval==''){
        this.CoureseParam.courseName='';
        this.chapterparam.courseId='';
        this.chapterlistData=[];
        this.chapterstatue=true;
      }else{
        let searchcourse=this.CoureRestaurants.filter(item=>item.courseId==this.param.courseId)[0];
        this.CoureseParam.courseName=searchcourse.courseName;
        this.chapterparam.courseId=searchcourse.courseId;
        this.chapterstatue=false;
        this.chapterlist();
      }
      this.AllCourse();
    },
    
    'param.chapterId'(newval,oldval){
      this.chapterparam['courseId']=newval;
        this.chapterlist();
    }
  },
  activated() {
    this.list();
    this.AllCourse();
  },
  methods:{
    list(num){
      this.exammanageload=true;
      this.param['pageNum']=num==0?1:this.param['pageNum'];
      this.$Http_Post('edu/question/list',this.param).then(res=>{
        if(res.Code==0){
          this.exammanageData=res.Data;
          this.param.Total=res.Counts;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.exammanageload=false;
      });
    },
    // 删除
    ClickDelete(e){
      this.$Http_Post('edu/question/remove/'+e.questionId).then(res=>{
        if(res.Code==0){
          this.list();
          this.$message({type: 'success', message:res.Message});
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.exammanageload=false;
      });
    },

    // 获取全部课程
    AllCourse(){
      this.$Http_Post('edu/course/list',this.CoureseParam).then(res=>{
        if(res.Code==0){
          this.CoureRestaurants=res.Data;
        }else{
          this.$message({type: 'error', message:'获取课程列表失败'});
        }
      })
    },
    // 获取课程下的章节
    chapterlist(){
      this.$Http_Post('edu/chapter/list',this.chapterparam).then(res=>{
        if(res.Code==0){
          this.chapterlistData=res.Data;
        }else{
          this.$message({type: 'error', message:'章节列表获取失败'});
        }
      })
    },
    // 分页
    handleCurrentChange(val){
      this.param.pageNum=val;
      this.list();
    },
    filterCourse(val){
      this.CoureseParam['courseName']=val;debugger;
      this.AllCourse();
    },

    // 查询章节
    filterchapter(val){
      this.chapterparam['chapterName']=val;
      this.chapterlist();
    },

    // 查看详情
    ClickDetail(e){
      this.questionId=e;
      this.topicdetail=true;
    },
    // 上传前
    beforeupload(file){
      this.Loading=true;
      if(file.name.indexOf('xls')==-1 || file.name.indexOf('xlsx')==-1){
        this.$message({type: 'error', message:"请上传xlsx或者xls文件"});
        return false;
      }
    },
    submitUpload(){
      this.$refs.upload.submit();
    },
    //题目导入
    handsuccess(file,fileList){
      this.Loading=false;
      if(file.Code==0){
        this.list();
        this.$message({type: 'success', message:file.Message});
        this.importdialog=false;
      }else{
        this.fileList=[];
        this.$message({type: 'error', message:'导入失败，错误信息文件将自动下载'});
        location.href=file.Data;
      }
    },
    // 下载试题模板
    Clickdownload(){
      location.href=process.env.VUE_APP_URL+'edu/question/template/download'
    },

    // 加入试卷
    clickJoinexam(){
      sessionStorage.setItem('examListID',JSON.stringify(this.examListID));
      this.$router.go(-1);
    },
    // 重置
    Clickreset(){
      this.param=this.$options.data().param;
      this.list();
    }

  },
  components:{
    questiondetail
  }
})
</script>
<style scoped>
.header{display: flex;align-items:center;background: #fff;padding:10px 30px;}
.content{background:#fff;padding:30px;margin:20px 0;}
.operateitem{padding: 0 5px 0 0;color: #409EFF;cursor: pointer;}
.upload-demo{display: inline-block;margin-left:20px;}
.topicdetail p{font-size: 16px;}
.topicdetail p span{text-align: right;width: 100px;display: inline-block;}
.topicdetail i{color: red;padding:0 5px;}
.topicdetail .item{display: table-cell;font-size: 16px;}
.manage{padding: 0 5px 0 0;color: #409EFF;cursor: pointer;}
</style>